import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useLanguage } from '../contexts/LanguageContext';

function Copyright() {
  const { translations } = useLanguage();

  return (
    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
      {translations.footer_section.copyright} {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  const { translations } = useLanguage();

  return (
    <Container sx={{ py: { xs: 5, sm: 6 } }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
          pt: { xs: 3, sm: 4 },
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Copyright />
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
          <Link
            color="text.secondary"
            variant="body2"
            href="/terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            {translations.footer_section.terms_conditions}
          </Link>
          <Link
            color="text.secondary"
            variant="body2"
            href="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            {translations.footer_section.privacy_policy}
          </Link>
        </Stack>
      </Box>
    </Container>
  );
}
